import api from "./api";

export const getSituacaoCadastro = async () => {
    try {
        const response = await api.get("/situacaoCadastro_");
        return response.data;
    } catch (error) {
        console.error(error);
        return null;
    }
}